import {
  ACTION_DETACH_GOOGLE__REQUEST,
  ACTION_DETACH_GOOGLE__SUCCESS,
  ACTION_DETACH_GOOGLE__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_DETACH_GOOGLE__REQUEST:
    case ACTION_DETACH_GOOGLE__SUCCESS:
      return null;

    case ACTION_DETACH_GOOGLE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
